import { Box, Typography } from '@mui/material';

import Icons from '../../themes/icons';

export const ViolationMessage: React.FC = () => {
  return (
    <Box
      sx={{
        backgroundColor: '#765BC6',
        padding: '10px',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
      }}
    >
      <Icons.SecureIcon />
      <Typography fontSize={'15px'} fontFamily={'Poppins'} fontWeight={'400'}>
        <Typography fontWeight={'500'} component={'span'}>
          Do not make deals outside the app.
        </Typography>{' '}
        This ensures secure transactions and protects your account. Violations may result in account
        suspension.
      </Typography>
    </Box>
  );
};
